import axios from 'axios';
import { path_to_site } from './axios_settings';
import { handleNetworkError } from '../utils/networkErrorHandler';

// Функция для отправки заказа на сервер
export const submitOrder = async (orderData) => {
  try {
    const formData = new FormData();
    formData.append('request', 'submit_order');

    // Добавляем все данные заказа
    formData.append('order_data', JSON.stringify(orderData));

    const response = await axios.post(path_to_site, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    // Выводим ответ в дебаг
    //console.log('=== ORDER SUBMISSION RESPONSE ===');
    //console.log('Response status:', response.status);
    //console.log('Response data:', response.data);
    //console.log('Full response:', response);
    //console.log('=== END ORDER SUBMISSION RESPONSE ===');

    return response.data;
  } catch (error) {
    // Выводим ошибку в дебаг
    // console.error('=== ORDER SUBMISSION ERROR ===');
    // console.error('Error:', error);
    // console.error('Error response:', error.response);
    // console.error('Error message:', error.message);
    // console.error('=== END ORDER SUBMISSION ERROR ===');

    // Обрабатываем сетевые ошибки (отсутствие интернета)
    if (handleNetworkError(error)) {
      throw new Error('Нет подключения к интернету');
    }

    // Для других ошибок
    throw error;
  }
};

export default submitOrder;
